// ChalkOS logo system — chunky chalkboard badge with X · O · arrow inside.
// The badge is the canonical brand mark. Wordmark + tagline sit alongside.

export function ChalkLogoMark({ size = 40 }) {
  // Solid dark-green rounded square, white chalk strokes drawing X (top-left),
  // O (top-right), and a curved arrow (bottom). Reads as "play diagrams".
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, display: "block" }}
    >
      <rect width="40" height="40" rx="10" fill="#1a3a2a" />
      {/* X */}
      <g stroke="#F5F0E8" strokeWidth="2.2" strokeLinecap="round" opacity="0.96">
        <line x1="9" y1="9" x2="17" y2="17" />
        <line x1="17" y1="9" x2="9" y2="17" />
      </g>
      {/* O */}
      <circle cx="27" cy="13" r="4.4" fill="none" stroke="#F5F0E8" strokeWidth="2.2" opacity="0.96" />
      {/* dashed arrow */}
      <g stroke="#4db87a" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 30 Q 18 22 28 28" strokeDasharray="3 3" />
        <path d="M25 25 L 28.5 28.2 L 25.4 31" />
      </g>
    </svg>
  );
}

// Wordmark — Bebas Neue, all caps, tight tracking. Used in nav lockups.
export function ChalkWordmark({ size = 22, color = "#1a1a1a" }) {
  return (
    <span
      style={{
        fontFamily: "'Bebas Neue', Oswald, Impact, sans-serif",
        fontSize: size,
        color,
        letterSpacing: "0.04em",
        lineHeight: 1,
        textTransform: "uppercase",
        fontWeight: 400,
      }}
    >
      Chalk&nbsp;OS
    </span>
  );
}

// Stacked lockup — badge + (wordmark over tagline). Default brand expression.
// Tagline auto-hides for small sizes (<32px) to keep tight headers clean;
// pass `tagline={false}` or `tagline` explicitly to override.
export function ChalkLogoLockup({ size = 36, color = "#1a1a1a", tagline }) {
  const showTagline = tagline === undefined ? size >= 32 : tagline;
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>
      <ChalkLogoMark size={size} />
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: 2 }}>
        <ChalkWordmark size={Math.round(size * 0.6)} color={color} />
        {showTagline && (
          <span
            style={{
              fontFamily: "'Barlow', system-ui, sans-serif",
              fontSize: 9.5,
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#2E7D52",
              lineHeight: 1,
            }}
          >
            Draw it up. Get it done.
          </span>
        )}
      </div>
    </div>
  );
}
